<app-navbar title="Terminy płatności wynajmy"> </app-navbar>

<app-event-business-filters
	userFilters="eventBusiness"
	[statusNames]="parameters.statusNames"
	[organization]="parameters.organization"
	[profile]="parameters.profile"
	[documentTypes]="parameters.documentTypes"
	[owners]="parameters.owners"
	[yesno]="parameters.yesno"
	(selected)="filtersSelected($event)"
></app-event-business-filters>

<div class="card-body">
	<div class="form-inline">
		<label class="me-4">
			Suma kwot na umowie PLN:
			{{ this.sumAgreementPLN.toFixed(2) }}
			PLN
		</label>
		<label class="me-4">
			Suma kwot na umowie EUR:
			{{ this.sumAgreementEUR.toFixed(2) }}
			EUR
		</label>
		<label class="me-4">
			Pozostało do zapłaty(całość):
			{{ this.sumSettledPLN.toFixed(2) }}
			PLN
		</label>
		<label class="me-4">
			Pozostało do zapłaty(całość):
			{{ this.sumSettledEUR.toFixed(2) }}
			EUR
		</label>
	</div>
</div>
<app-dynamic-table-v2
	[module]="'eventBusiness'"
	[elements]="data"
	elementLinkPostfix="payments"
	[columns]="tableRows"
	[pageSizeOptions]="pageSizeOptions"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table-v2>
